module.exports = __webpack_public_path__ + "static/media/TEACH_yuliClass.00201c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TEACH_yuliClass.png
// module id = 166
// module chunks = 0